export interface PlaceholderSource {
  PARTNER_NAME: string;
  PROGRAM_NAME: string;
  PARTNER_EMAIL: string;
  PARTNER_PHONE: string;
  APPROVED_AMOUNT: string;
  MAX_AMOUNT: string;
  APPLICANT_NAME: string;
  APPLICANT_EMAIL: string;
  FAQ_PAGE: string;
}

const ENABLE_PLACEHOLDER = [
  {
    param: /{PARTNER_NAME}/g,
    key: 'PARTNER_NAME',
  },
  {
    param: '{PROGRAM_NAME}',
    key: 'PROGRAM_NAME',
  },
  {
    param: /{PARTNER_EMAIL}/g,
    key: 'PARTNER_EMAIL',
  },
  {
    param: /{PARTNER_PHONE}/g,
    key: 'PARTNER_PHONE',
  },
  {
    param: /{APPROVED_AMOUNT}/g,
    key: 'APPROVED_AMOUNT',
  },
  {
    param: /{MAX_AMOUNT}/g,
    key: 'MAX_AMOUNT',
  },
  {
    param: /{APPLICANT_NAME}/g,
    key: 'APPLICANT_NAME',
  },
  {
    param: /{APPLICANT_EMAIL}/g,
    key: 'APPLICANT_EMAIL',
  },
  {
    param: /{FAQ_PAGE}/g,
    key: 'FAQ_PAGE',
  },
];

export default (text: string, source: PlaceholderSource): string => {
  if (!text) return null;
  let replacedText = text;
  for (const placeholder of ENABLE_PLACEHOLDER)
    replacedText = replacedText.replace(placeholder.param, source[placeholder.key]);
  return replacedText;
};
